import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
    standalone: true,
    imports: [SharedModule],
  selector: 'app-action-renderer',
  templateUrl: './action-renderer.component.html',
  styleUrls: ['./action-renderer.component.scss']
})
export class ActionRendererComponent {


  params: any;
  commentCount:any;
  label!: string;
  hideCommentCount: boolean= false;
  public actionsList = [
    {
     name: 'add',
     code: 'ADD',
     key: 'add',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1 add-icon'
    },
    {
      name: 'ios_share',
      code: 'EXPORT',
      key: 'export',
      isDisabled: this.isDisabled.bind(this),
      isShow:  this.isShow.bind(this),
      count:  this.count.bind(this),
      class: 'material-icons material-symbols-outlined'
     },
     {
      name: 'schedule',
      code: 'SCHEDULE',
      key: 'schedule',
      isDisabled: this.isDisabled.bind(this),
      isShow:  this.isShow.bind(this),
      count:  this.count.bind(this),
      class: 'material-icons material-symbols-outlined'
     },
    {
     name: 'edit',
     code: 'EDIT',
     key: 'edit',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1 edit-icon',
    },
    {
     name: 'copy',
     code: 'COPY',
     key: 'copy',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1 copy-icon',
    },
    {
      name: 'view',
      code: 'VIEW',
      key: 'eye',
      isDisabled: this.isDisabled.bind(this),
      isShow: this.isShow.bind(this),
      count: this.count.bind(this),
      class: 'pe-1 view-icon'
    },
    {
     name: 'share',
     code: 'SHARE',
     key: 'share',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1 share-icon',
    },
    {
      name: 'check',
      code: 'APPROVE',
      key: 'approve',
      isDisabled: this.isDisabled.bind(this),
      isShow: this.isShow.bind(this),
      count: this.count.bind(this),
      class: 'pe-1 check-icon'
    },
    {
      name: 'close',
      code: 'CANCEL',
      key: 'cancel',
      isDisabled: this.isDisabled.bind(this),
      isShow: this.isShow.bind(this),
      count: this.count.bind(this),
      class: 'pe-1 cancel-icon'
    },
    {
     name: 'delete',
     code: 'DELETE',
     key: 'delete',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1 delete-icon'
    },
    {
     name: 'leave',
     code: 'LEAVE',
     key: 'leave',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'chart-icon pe-1'
    },
    {
     name: 'notifications_off',
     code: 'UNSUBSCRIBE',
     key: 'unsubscribe',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'notif-off-icon pe-1',

    },
    {
     name: 'show_chart',
     code: 'SHOW_CHART',
     key: 'showChart',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'chart-icon pe-1'
    },
    {
     name: 'subject',
     code: 'SHOW_LOGS',
     key: 'showLogs',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'subject-icon pe-1'
    },
    {
     name: 'play_arrow',
     code: 'TEST',
     key: 'test',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'play-icon pe-1'
    },
    {
     name: 'comment',
     code: 'COMMENTS_PANEL',
     key: 'commentsPanel',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1'
    },
    {
     name: 'visibility_off',
     code: 'VISIBILITY_OFF',
     key: 'visibilityOff',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'visibility-off-icon pe-1'
    },
    {
      name: 'finance',
      code: 'finance',
      key: 'track',
      isDisabled: this.isDisabled.bind(this),
      isShow:  this.isShow.bind(this),
      count:  this.count.bind(this),
      class: 'material-symbols-outlined pe-1',
     },
     {
      name: 'restart_alt',
      code: 'Regenerate',
      key: 'regenerate',
      isDisabled: this.isDisabled.bind(this),
      isShow:  this.isShow.bind(this),
      count:  this.count.bind(this),
      class: 'pe-1'
     },
         {
     name: 'open_in_new_down',
     code: 'OPEN',
     key: 'open',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'material-symbols-outlined pe-1'
    },
    {
     name: 'sync',
     code: 'SYNC',
     key: 'sync',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'material-symbols-outlined pe-1'
    },
    {
     name: 'design',
     code: 'DESIGN',
     key: 'design',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'material-symbols-outlined pe-1'
    },
    {
     name: 'media',
     code: 'MEDIA',
     key: 'media',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'material-symbols-outlined pe-1'
    },
    {
     name: 'change',
     code: 'CHANGE',
     key: 'change',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'material-symbols-outlined pe-1'
    },
    // DN-3562 group member screen permission
    {
     name: 'Screen Permissions',
     code: 'SCREEN_PERMISSIONS',
     key: 'safety',
     isDisabled: this.isDisabled.bind(this),
     isShow:  this.isShow.bind(this),
     count:  this.count.bind(this),
     class: 'pe-1'
    },
  ]
  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
    if(params.data)
    {
      if(params.data.journeyContextLogs == undefined)
      {
        this.hideCommentCount = false;
        this.commentCount =  params.data.commentCount
      }else{this.hideCommentCount = true;}
    }
    if(params.data && params.data.journeyContextLogs  && params.data.journeyContextLogs == 0)
    {
      this.commentCount = 0;
      this.hideCommentCount = true;
    }
  }

  refresh(params?: any): boolean {
    return true;
  }
  getTooltipTitle(action: any): string {
    // Optional per-grid label override passed via cellRendererParams, e.g. { tooltips: { copy: 'Duplicate' } }
    return (this.params && this.params.tooltips && this.params.tooltips[action.key]) || action.name;
  }
  getTooltip(action: any): string {
    switch (action.key) {
      case 'add':
        return 'Add a new item';
      case 'edit':
        return this.params.data && this.params.data.kpiSubscriptionId
        ? 'Edit Rule'
        : 'Edit';
      case 'share':
        return this.params.data && this.params.data.kpiSubscriptionId
        ? 'Share Rule'
        : 'Share';
      case 'view':
        return this.params.data && this.params.data.kpiSubscriptionId
        ? 'View Rule'
        : 'View';
      case 'delete':
        return this.params.data && this.params.data.kpiSubscriptionId
        ? 'Delete Rule'
        : 'Delete';
      case 'unsubscribe':
        return this.params.data && this.params.data.kpiSubscriptionId
        ? 'Unsubscribe Rule'
        : 'Unsubscribe';
      case 'showChart':
        return 'Show Chart';
      case 'showLogs':
        return 'Show Logs';
      case 'track':
        return 'Track Progress'
      case 'regenerate':
        return 'Regenerate';
      case 'open':
        return 'Open';
      default:
        return '';
    }
  }
  onClick($event: any) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }
  public isDisabled(params: any, action: any) {
    if (action.key === 'cancel'|| action.key === 'edit') {
      return params?.data?.status === 'Completed' || params?.data?.status === 'Failed' || params?.data?.status === 'Cancelled' || (params.data && params.data.isException && params.data.status === 1);
    }
    if (action.key === 'commentsPanel') {
      return params.data && !params.data.commentCount;
    }
    if (action.key === 'leave') {
      if (params.data.journeyContextLogId) {
        return params.data.isJourney;
      } else {
        return false;
      }
    }
    if (action.key === 'share') {
      return params.data && params.data.isPrivate;
    }
    if (action.key === 'approve') {
      return (params.data && params.data.isException && params.data.status == 1)
    }
    return false;
  }
  public isShow(params: any, action: any) {
    return params[action.key] && params[action.key](params, action.key);
  }
  public count(params: any, action: any) {
    if (action.key === 'commentsPanel')
    return params.data && params.data.commentCount;
  }
}
